import { Layout } from "antd";
import CompanyLogo from "assets/aktos-logo-1004x923.png";
import { useWhiteLabel } from "providers/whiteLabelProvider";
import styled from "styled-components";

const StyledImg = styled.img`
  margin-left: 8px;
  height: 48px;
  max-width: 220px;
  object-fit: contain;
`;

const StyledHeader = styled(Layout.Header)`
  min-width: 470px;
  display: flex;
  align-items: center;
  z-index: 10;
  border-bottom: 1px solid #d9d9d9;
  background: #fff;
  @media only screen and (max-width: 470px) {
    display: none;
  }
  &&& {
    padding-inline: 0;
  }
`;

function LoginPageLayout({ children }) {
  const { isWhiteLabeled, logo } = useWhiteLabel();

  return (
    <>
      <StyledHeader>
        <StyledImg alt="Logo" src={isWhiteLabeled ? logo : CompanyLogo} />
      </StyledHeader>
      {children}
    </>
  );
}

export default LoginPageLayout;
